const ScreenName = {
  HomePage: "home",
  ProductDetailPage: "pdp",
  CartPage: "cart",
  Wishlist: "wishlist",
  ErrorPage: "errorpage",
};

export default ScreenName;
